/* eslint-disable */

/**
 * Generated Code - Original file ist legacy-street-suggest.ts
 */

import {
  InterfacePlaceDetail,
  InterfacePlacesList,
} from '../orderform-widgets/src/lib/components/inputs-generator/address-suggest-plugin/interface';

interface AutoSuggestConfig {
  streetId: string;
  streetNrId: string;
  plzId: string;
  cityId: string;
  stateId: string;
  countryId: string;
  is_street_number_hidden: boolean;
  is_street_number_before_street: boolean;
  language: string;
}

declare const $;

const configs: AutoSuggestConfig[] = window['AutoSuggestConfigs'] || [];
window['initedConfigs'] = window['initedConfigs'] || {};

const createUUID = () => {
  try {
    return crypto.randomUUID();
  } catch (e) {
    return 'uuid-not-supported';
  }
};

function runAutoSuggestScript(config: AutoSuggestConfig) {
  const key = JSON.stringify(config); // generate key by config
  const sessionBasedAutocomplete = false;

  if (window.location.search.indexOf('test_skip_autocomplete=1') >= 0) {
    return;
  }

  /**
   * Prevent multible loads by configuration
   */
  if (window['initedConfigs'][key]) {
    console.log('prevent multible load for', key);
    return false;
  } else {
    window['initedConfigs'][key] = true;
  }

  if (config && $) {
    const activateSuggestInputLength = 2;
    const streetInput = $(`#${config.streetId}`);
    const streetNrInput = $(`#${config.streetNrId}`);
    const plzInput = $(`#${config.plzId}`);
    const cityInput = $(`#${config.cityId}`);
    const stateInput = $(`#${config.stateId}`);
    const countryInput = $(`#${config.countryId}`);
    let sessionToken = createUUID();

    /**
     * Create initial container for street results
     * and add this to body
     */
    const suggestContainer = $(
      '<ul data-e2e="street-suggest" style="display: none; margin: 0 ; padding: 0;background: #fff;box-shadow: 0 0 3px 0 #999;border-radius: 3px;"></ul>'
    ).appendTo('body');

    // Expose a hook for JavaScript when auto fill is shown.
    // JavaScript can capture 'animationstart' events
    $(`<style>
      #${config.streetId}:-webkit-autofill { animation-name: onAutoFillStart; animation-duration: 0.001s }
      #${config.streetId}:not(:-webkit-autofill) { animation-name: onAutoFillCancel; animation-duration: 0.001s }
      @keyframes onAutoFillStart { from {/**/} to {/**/} }
      @keyframes onAutoFillCancel { from {/**/} to {/**/} }
</style>`).appendTo('head');

    let suggestListController: AbortController;
    const getSuggestionList = (
      input: string,
      sessionToken: string
    ): Promise<InterfacePlacesList.Prediction[]> => {
      suggestListController = new AbortController();
      const promise = fetch(
        `/v2/api/public/autocomplete?input=${input}&language=${
          config.language
        }&types=address${
          sessionBasedAutocomplete ? '&sessiontoken=' + sessionToken : ''
        }`,
        {
          signal: suggestListController.signal,
        }
      ).then((response) => response.json());
      return promise
        .then(
          (result: InterfacePlacesList.RootObject) => result?.predictions || []
        )
        .catch(() => {
          return Promise.resolve([]);
        });
    };

    /**
     * Get place details for list item by place ID
     * @param placeID
     * @param sessionToken
     */
    const getSuggestDetails = (
      placeID: string,
      sessionToken: string
    ): Promise<InterfacePlaceDetail.Result> => {
      return fetch(
        `/v2/api/public/autocomplete/place?place_id=${placeID}&language=${
          config.language
        }&fields=address_components${
          sessionBasedAutocomplete ? '&sessiontoken=' + sessionToken : ''
        }`
      )
        .then((response) => response.json())
        .then((result: InterfacePlaceDetail.RootObject) => result.result);
    };

    /**
     * calculate position of the suggest container
     * @param display
     */
    const calcPositionOfSuggest = (display: 'block' | 'none' = 'block') => {
      const inputRef = streetInput[0];
      const suggestContainerRef = suggestContainer[0];
      const inputPos = inputRef.getBoundingClientRect();
      const top = inputPos.top + window.scrollY + inputPos.height;
      const left = inputPos.left + window.scrollX;
      suggestContainerRef.style.display = display;
      suggestContainerRef.style.position = 'absolute';
      suggestContainerRef.style.zIndex = '999';
      suggestContainerRef.style.top = top + 'px';
      suggestContainerRef.style.left = left + 'px';
      suggestContainerRef.style.width = inputPos.width + 'px';
    };

    /**
     * Update list container with new results
     * @param suggests
     */
    const createSuggestList = (
      suggests: InterfacePlacesList.Prediction[] = []
    ) => {
      suggestContainer.empty();
      suggests.forEach((suggest) => {
        const li = $(`<li style="display: block;
      padding: 6px 12px;
      border-bottom: 1px solid #ccc;
      cursor: pointer;">${suggest.description}</li>`).click(() => {
          applySuggest(suggest);
        });
        suggestContainer.append(li);
      });
    };

    /**
     * Click on list item
     * @param suggest
     */
    const applySuggest = (suggest: InterfacePlacesList.Prediction) => {
      // MockResult
      getSuggestDetails(suggest.place_id, sessionToken).then((place) => {
        handleSuggestSelect(
          config.streetId,
          config.streetNrId,
          config.plzId,
          config.cityId,
          config.stateId,
          config.countryId,
          config.is_street_number_hidden,
          config.is_street_number_before_street,
          place
        );
        /*
         * Die Sitzung endet bei Google, wenn die Details abgefragt wurden.
         * Deshalb wird an dieser Stelle ein neues Token erzeugt.
         */
        sessionToken = createUUID();
      });
    };

    /**
     * Apply data of place to the fields (CI Fields)
     * @param streetId
     * @param streetNrId
     * @param plzId
     * @param cityId
     * @param stateId
     * @param countryId
     * @param is_street_number_hidden
     * @param is_street_number_before_street
     * @param place
     */
    const handleSuggestSelect = (
      streetId,
      streetNrId,
      plzId,
      cityId,
      stateId,
      countryId,
      is_street_number_hidden,
      is_street_number_before_street,
      place: InterfacePlaceDetail.Result
    ) => {
      /**
       * Default values & mappings
       */
      const componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'short_name',
        postal_code: 'short_name',
      };
      const elementsMap = {
        street_number: streetNrId,
        route: streetId,
        locality: cityId,
        administrative_area_level_1: stateId,
        country: countryId,
        postal_code: plzId,
      };
      const sanitizedValues = {
        street_number: '',
        route: '',
        locality: '',
        administrative_area_level_1: '',
        country: '',
        postal_code: '',
      };

      /**
       * Country element for event emit on change
       */
      const country_input = document.getElementById(
        elementsMap.country
      ) as HTMLSelectElement;
      const zipcode_input: HTMLElement = document.getElementById(
        elementsMap.postal_code
      );

      const getValueOfField = (id: string) => {
        const field = document.getElementById(id) as HTMLInputElement;
        return field.value;
      };
      const previous_country = getValueOfField(elementsMap.country);
      const previous_zipcode = getValueOfField(elementsMap.postal_code);

      let country_name = '';

      place.address_components.forEach((item) => {
        const addressType = item.types[0];
        if (componentForm[addressType]) {
          const val = item[componentForm[addressType]];
          if (typeof sanitizedValues[addressType] != 'undefined') {
            sanitizedValues[addressType] = val;
            if (addressType === 'country') {
              country_name = item['long_name'];
            }
          }
        }
      });

      // if suggest without country found, do nothing
      if (!sanitizedValues.country) {
        return;
      }

      // const is_country_valid = previous_country === sanitizedValues.country;
      // if (!is_country_valid) {
      //   // @ts-ignore
      //   var message = window.lang_form.form_err_no_delivery_to_country.replace(
      //     /\%s/,
      //     country_name ? country_name : sanitizedValues.country
      //   );
      //   country_input.value = previous_country;
      //   // @ts-ignore
      //   window.setFormStatus(streetNrId, 'error', message);
      //   return;
      // }

      const is_country_changed = sanitizedValues?.country != previous_country;
      const is_zipcode_changed =
        sanitizedValues?.postal_code != previous_zipcode;

      if (is_street_number_hidden) {
        const street_number = sanitizedValues.street_number;
        if (street_number) {
          sanitizedValues.route = is_street_number_before_street
            ? street_number + ' ' + sanitizedValues.route
            : sanitizedValues.route + ' ' + street_number;
        }
      }

      Object.keys(sanitizedValues).forEach((addressType) => {
        const val = sanitizedValues[addressType];
        const elementId = elementsMap[addressType];
        const input = document.getElementById(elementId) as HTMLInputElement;
        if (elementId && input) {
          input.disabled = false;
          input.value = val;
          $(input).trigger('focusout');
        }
      });

      if (is_country_changed) {
        $(country_input).trigger('change');
      }

      if (is_zipcode_changed) {
        $(zipcode_input).trigger('change');
      }
    };

    const initAutoCompleteAttribute = streetInput.attr('autocomplete');
    const disableBrowserSuggest = () => {
      streetInput.attr('autocomplete', 'new-password');
    };

    const enableBrowserSuggest = () => {
      if (initAutoCompleteAttribute) {
        streetInput.attr('autocomplete', initAutoCompleteAttribute);
      }
    };

    const checkInputBrowserSuggest = (value: string) => {
      if (value?.length > activateSuggestInputLength) {
        disableBrowserSuggest();
      } else {
        enableBrowserSuggest();
      }
    };

    /**
     * On enter to request for list
     */
    let enterTimeout = null,
      hasAutoFill = false;
    streetInput.bind('keyup', function () {
      if (hasAutoFill) {
        return;
      }
      const value = $(this).val();

      checkInputBrowserSuggest(value);

      // show results
      if (value.length > activateSuggestInputLength) {
        calcPositionOfSuggest('block');
      } else {
        calcPositionOfSuggest('none');
        return;
      }

      clearTimeout(enterTimeout);
      // Abort prev request if exists
      if (suggestListController) {
        suggestListController.abort();
      }
      enterTimeout = setTimeout(() => {
        getSuggestionList(value, sessionToken).then((suggests) => {
          createSuggestList(suggests);
        });
      }, 250);
    });

    streetInput.bind('animationstart', function (e) {
      switch (e.originalEvent.animationName) {
        case 'onAutoFillStart':
          hasAutoFill = true;
          clearTimeout(enterTimeout);
          break;
        case 'onAutoFillCancel':
          hasAutoFill = false;
          break;
      }
    });

    // display list on focus!!!
    streetInput.bind('focus', function () {
      calcPositionOfSuggest('block');
    });

    // hide list on focus!!!
    streetInput.bind('blur', function () {
      setTimeout(() => calcPositionOfSuggest('none'), 250);
    });

    /**
     * Initial start if value exists
     */
    if (streetInput.val()) {
      checkInputBrowserSuggest(streetInput.val());

      /**
       * get direct suggestion list
       */
      getSuggestionList(streetInput.val(), sessionToken).then((suggests) => {
        createSuggestList(suggests);
      });
    }
  }
}

configs.forEach((config) => runAutoSuggestScript(config));

/* eslint-enable */
